import { BRAND_VALUE_FILTER_TYPE, getFilterValueFromFilterKey, isFilterKeyOfType } from "@faire/retailer-shared/filters/filterKeys";
import { categoryBrandValuePath } from "@faire/retailer-visitor-shared/paths/category/categoryBrandValuePath";
import { categoryPath } from "@faire/retailer-visitor-shared/paths/category/categoryPath";
import { suppliersBrandValuePath } from "@faire/retailer-visitor-shared/paths/suppliers/suppliersBrandValuePath";
import { suppliersPath } from "@faire/retailer-visitor-shared/paths/suppliers/suppliersPath";
import { logError } from "@faire/web--source/common/logging";
import { isNotUndefined, isTupleOfLengthGreaterThanOrEqual } from "@faire/web--source/common/typescriptUtils";
import { prependLocaleToUrl } from "@faire/web--source/ui/routing/util";
import { route as homepageRoute } from "@faire/web-api--source/routes/www/root";
export var CategoryPagePaths;
(function(CategoryPagePaths) {
    var RouteType;
    (function(RouteType) {
        RouteType["CATEGORY"] = "category";
        RouteType["SUPPLIERS"] = "suppliers";
    })(RouteType = CategoryPagePaths.RouteType || (CategoryPagePaths.RouteType = {}));
    /**
     * @deprecated
     *
     * Do not use this function as it is a heavy way to build a category path.
     * Instead use the more targetted helper functions under src/paths/category to get the
     * appropriate path depending on the parameters available.
     */ function index(param) {
        var categoryUrlIds = param.categoryUrlIds, _param_queryParams = param.queryParams, queryParams = _param_queryParams === void 0 ? {} : _param_queryParams, filterByBrandValueOption = param.filterByBrandValueOption, _param_routeType = param.routeType, routeType = _param_routeType === void 0 ? RouteType.CATEGORY : _param_routeType, routingContext = param.routingContext;
        var filteredCategoryUrlIds = categoryUrlIds.filter(isNotUndefined);
        if (!isTupleOfLengthGreaterThanOrEqual(filteredCategoryUrlIds, 1)) {
            logError(new Error("CategoryPathPaths.index must have at least one category"));
            return prependLocaleToUrl(homepageRoute, routingContext);
        }
        if (routeType === RouteType.SUPPLIERS) {
            if (filterByBrandValueOption) {
                var brandValue = getBrandValueFromParam(filterByBrandValueOption);
                return suppliersBrandValuePath({
                    urlIds: filteredCategoryUrlIds,
                    brandValue: brandValue,
                    queryParams: queryParams,
                    routingContext: routingContext
                });
            } else {
                return suppliersPath({
                    urlIds: filteredCategoryUrlIds,
                    queryParams: queryParams,
                    routingContext: routingContext
                });
            }
        }
        if (filterByBrandValueOption) {
            var brandValue1 = getBrandValueFromParam(filterByBrandValueOption);
            return categoryBrandValuePath({
                urlIds: filteredCategoryUrlIds,
                brandValue: brandValue1,
                queryParams: queryParams,
                routingContext: routingContext
            });
        } else {
            return categoryPath({
                urlIds: filteredCategoryUrlIds,
                queryParams: queryParams,
                routingContext: routingContext
            });
        }
    }
    CategoryPagePaths.index = index;
    CategoryPagePaths.getRouteType = function(suppliersCategoryName) {
        return suppliersCategoryName ? CategoryPagePaths.RouteType.SUPPLIERS : CategoryPagePaths.RouteType.CATEGORY;
    };
})(CategoryPagePaths || (CategoryPagePaths = {}));
var getBrandValueFromParam = function(filterByBrandValueOption) {
    var brandValue = filterByBrandValueOption;
    if (isFilterKeyOfType(filterByBrandValueOption, BRAND_VALUE_FILTER_TYPE)) {
        var _getFilterValueFromFilterKey;
        brandValue = (_getFilterValueFromFilterKey = getFilterValueFromFilterKey(filterByBrandValueOption)) !== null && _getFilterValueFromFilterKey !== void 0 ? _getFilterValueFromFilterKey : brandValue;
    }
    return brandValue.replace(/_/g, "-");
};
